import React, { useEffect, useRef, useState } from "react";
import { Tooltip, UncontrolledTooltip } from "reactstrap";
import { Edit, Edit2, Mail } from "react-feather";
import { useLocation } from "react-router-dom";

import EditProduct from "../../Pages/Product/Components/EditProduct";
import { FlagContainer } from "./FlagContainer";
import { flaggedCheckedList } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { updateVideoPageState } from "../../Pages/Video/VideoActions";
import { updateProductPageState } from "../../Pages/Product/productActions";

const NoteText = ({ text, update, submit, isCreator }) => (
  <div
    className="note"
    style={{ right: isCreator === "creators" ? "0px" : "" }}
  >
    <div className="note-header">Note</div>
    <textarea className="note-input" value={text} onChange={update} />
    <span role="button" className="note-button" onClick={submit}>
      Save
    </span>
  </div>
);

const initialStates = {
  open: false,
  openEditProduct: false,
  favTooltipOpen: false,
  flagTooltipOpen: false,
  editTooltipOpen: false,
  editProductTooltipOpen: false,
  isFlagReasonOpen: false,
  customFlagReason: "",
  text: "",
  isOtherOpen: false,
  selectedCheck: "",
  trashTooltipOpen: false,
};

const trashIcon =
  require("@src/assets/images/vyrill/grey_trash_icon.png").default;

const NoteSection = ({
  id,
  tab,
  note,
  title,
  is_index,
  updateNote,
  isInfluencer,
  product_edit,
  isCreatorNote,
  isEmailCopied,
  isEmailBlocked,
  handleCopyText,
  isFlagWithReason,
  detailPage,
  isVerticle,
  displayAtRight,
  isProduct,
  isDetailPage,
}) => {
  const [state, setState] = useState({ ...initialStates });
  const [openInfoSearch, setOpenInfoSearch] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(true);
  const [justaddedToFavorite, setJustAddedToFavorite] = useState(false);

  const isFlaggedTab = useSelector((state) => state.videoParams.isFlaggedTab);

  const isVideoFavoriteTab = useSelector(
    (state) => state.videoParams.isFavoriteTab
  );
  const isProductFavoriteTab = useSelector(
    (state) => state.productParams.isFavoriteTab
  );
  const isProductTrashTab = useSelector(
    (state) => state.productParams.isTrashTab
  );
  const iVideoTrashTab = useSelector((state) => state.videoParams.isTrashTab);

  const wrapperRef = useRef(null);
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setState({ ...state, isFlagReasonOpen: false });
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);
  }

  useEffect(() => {
    if (note.note) {
      setState({ ...state, text: note.note });
    }
  }, [note.note]);

  const toggleOpen = () => {
    setState({ ...state, open: !state.open });
  };

  const toggleFlagContainer = () => {
    if (flaggedCheckedList.includes(note.flagged_reason)) {
      setState({
        ...state,
        isFlagReasonOpen: !state.isFlagReasonOpen,
        selectedCheck: note.flagged_reason,
      });
    } else {
      //Other case
      if (note.flagged_reason === undefined || note.flagged_reason === null) {
        setState({
          ...state,
          isFlagReasonOpen: !state.isFlagReasonOpen,
          isOtherOpen: false,
          selectedCheck: "",
        });
      } else {
        setState({
          ...state,
          isFlagReasonOpen: !state.isFlagReasonOpen,
          customFlagReason: note.flagged_reason,
          isOtherOpen: true,
          selectedCheck: "Other",
        });
      }
    }
  };

  const updateText = ({ target }) => {
    setState({ ...state, text: target.value });
  };

  const toggle = (field) => () => {
    if (field === "flagged") {
      const flagged = note.flagged || note.flagged_video;
      return updateNote(id, { flagged: !flagged });
    }
    updateNote(id, { [field]: !note[field] });
  };

  const handleFavoriteItem = (field) => () => {
    if (pathname?.includes("videos") && isVideoFavoriteTab && note[field]) {
      dispatch(
        updateVideoPageState({
          confirmUnfav: true,
          isVideoDetailPage: true,
          favVideosCheckList: [id],
        })
      );
    } else if (pathname?.includes("products") && isProductFavoriteTab) {
      dispatch(
        updateProductPageState({
          unFavoriteModal: true,
          itemsCheckList: [id],
          isDetailPage,
        })
      );
    } else {
      if (!note.flagged_video) {
        setJustAddedToFavorite(!note[field] || false);
        updateNote(id, { [field]: !note[field] });
      }
    }
  };

  const submitText = () => {
    updateNote(id, { note: state.text });
    toggleOpen();
  };

  const reportFlagReason = () => {
    if (state.selectedCheck || state.customFlagReason) {
      if (state.selectedCheck === "Other" && state.customFlagReason) {
        updateNote(id, {
          flagged_reason: state.customFlagReason,
          flagged_video: true,
        });
        dispatch(
          updateVideoPageState({
            videoReportedAsFlagged: true,
            isVideoDetailPage: detailPage,
          })
        );
      } else {
        if (state.selectedCheck !== "Other") {
          updateNote(id, {
            flagged_reason: state.selectedCheck,
            flagged_video: true,
          });
          dispatch(
            updateVideoPageState({
              videoReportedAsFlagged: true,
              isVideoDetailPage: detailPage,
            })
          );
        }
      }
    }
  };

  const trashItem = () => {
    if (pathname.includes("products")) {
      if (isProductTrashTab) {
        dispatch(
          updateProductPageState({
            permanentDeleteModal: true,
            itemsCheckList: [id],
          })
        );
      } else {
        dispatch(
          updateProductPageState({
            moveToTrashModal: true,
            updateNote,
            itemId: id,
            isDetailPage,
          })
        );
      }
    }
    if (pathname.includes("videos")) {
      if (iVideoTrashTab) {
        dispatch(
          updateVideoPageState({
            confirmDelete: true,
            deleteVideosCheckList: [id],
          })
        );
      } else {
        dispatch(
          updateVideoPageState({
            trashConfirmationModal: true,
            itemId: id,
          })
        );
      }
    }
  };

  const showProductEdit = () => {
    setState({ ...state, openEditProduct: !state.openEditProduct });
  };

  const favtoggle = () => {
    setState({ ...state, favTooltipOpen: !state.favTooltipOpen });
  };

  const flagtoggle = () => {
    setState({ ...state, flagTooltipOpen: !state.flagTooltipOpen });
  };

  const editToggle = () => {
    setState({ ...state, editTooltipOpen: !state.editTooltipOpen });
  };

  const editProToggle = () => {
    setState({
      ...state,
      editProductTooltipOpen: !state.editProductTooltipOpen,
    });
  };

  const trashToggle = () => {
    setState({ ...state, trashTooltipOpen: !state.trashTooltipOpen });
  };

  const onChangeFlag = (e) => {
    const { value } = e.target;
    if (value === "Other") {
      setState({ ...state, selectedCheck: value, isOtherOpen: true });
    } else {
      setState({
        ...state,
        selectedCheck: value,
        isOtherOpen: false,
        customFlagReason: "",
      });
    }
  };

  const flagCustomReason = ({ target }) => {
    setState({ ...state, customFlagReason: target.value });
  };

  const handleMouseEnter = () => setIsMouseOver(false);

  const handleMouseLeave = () => {
    if (justaddedToFavorite) {
      setJustAddedToFavorite(false);
    }
    setIsMouseOver(false);
  };
  const favoriteHoverMessage = () => {
    if (isFlaggedTab) {
      return "Flagged videos can't be favorite";
    } else if ((justaddedToFavorite || isMouseOver) && note?.favorite) {
      return `You can now find this ${
        isProduct ? "product" : "video"
      } within the favorites folder`;
    } else if (note?.favorite) {
      return "Remove from Favorites";
    } else {
      return "Add to Favorites";
    }
  };
  const favoriteFeature = (
    <div>
      <span
        role="button"
        className="myDIV"
        id={`fav${id}`}
        onClick={handleFavoriteItem("favorite")}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={
            require(`@src/assets/images/vyrill/${
              note.favorite ? "active-heart.png" : "grey-heart.png"
            }`).default
          }
          alt=""
          width={14}
        />{" "}
      </span>
      <Tooltip
        placement="top"
        target={`fav${id}`}
        arrow="true"
        isOpen={state.favTooltipOpen}
        toggle={favtoggle}
      >
        {favoriteHoverMessage}
      </Tooltip>
    </div>
  );

  const handleFavoriteFeature = () => {
    if (isFlaggedTab) {
      return null;
    } else if (isInfluencer) {
      return favoriteFeature;
    } else if (!note.flagged || !note.flagged_video || !note.flagged_reason) {
      return favoriteFeature;
    } else {
      return null;
    }
  };

  const { open, text, openEditProduct } = state;
  return (
    <div
      className={`d-flex justify-content-between ${
        isVerticle && "flex-column gap-2 align-items-center"
      }`}
    >
      {isInfluencer && (
        <>
          <div>
            <span
              role="button"
              id={`mail${id}`}
              onClick={isEmailBlocked ? () => {} : handleCopyText}
            >
              <Mail
                size={15}
                color={
                  isEmailBlocked
                    ? "lightgrey"
                    : isEmailCopied
                    ? "red"
                    : "#808080"
                }
              />{" "}
            </span>
            <UncontrolledTooltip
              placement="top"
              target={`mail${id}`}
              arrow="true"
            >
              {title}
            </UncontrolledTooltip>
          </div>
        </>
      )}
      {/* Favroute icon */}
      {handleFavoriteFeature()}
      {isFlagWithReason && (
        // New Flagged Feature
        <div className="ms-1 me-1">
          <span
            role="button"
            id={`flag${id}`}
            onClick={
              (note.flagged || note.flagged_video || note.flagged_reason) &&
              isFlaggedTab
                ? () => {
                    dispatch(
                      updateVideoPageState({
                        confirmUnflag: true,
                        flaggedVideosCheckList: [id],
                        isVideoDetailPage: detailPage,
                      })
                    );
                  }
                : note.favorite
                ? () => {}
                : toggleFlagContainer
            }
            onMouseLeave={() => {
              setOpenInfoSearch(false);
            }}
            onMouseEnter={() => setOpenInfoSearch(true)}
          >
            <img
              src={
                require(`@src/assets/images/vyrill/${
                  note.flagged ||
                  note.flagged_video ||
                  note.flagged_reason ||
                  isFlaggedTab
                    ? "active-flagged.png"
                    : "grey-flagged.png"
                }`).default
              }
              alt=""
              width={11}
            />{" "}
          </span>
          {note.flagged ||
          note.flagged_video ||
          note.flagged_reason ||
          isFlaggedTab ? (
            openInfoSearch && (
              <div className="flagged-video-container">
                <span>unflag video</span>
              </div>
            )
          ) : (
            <Tooltip
              placement="top"
              target={`flag${id}`}
              arrow="true"
              isOpen={state.flagTooltipOpen}
              toggle={flagtoggle}
            >
              {note.favorite ? "Favorite videos can't be flagged." : "Flag"}
            </Tooltip>
          )}
          {state.isFlagReasonOpen && (
            <div
              className="flagg-container"
              ref={wrapperRef}
              style={
                detailPage
                  ? displayAtRight
                    ? { left: "auto", right: "1px" }
                    : { left: "auto" }
                  : {}
              }
            >
              <FlagContainer
                state={state}
                toggleFlagContainer={toggleFlagContainer}
                reportFlagReason={reportFlagReason}
                flagCustomReason={flagCustomReason}
                onChangeFlag={onChangeFlag}
              />
            </div>
          )}
        </div>
      )}
        <div>
          <span role="button" id={`trash${id}`} onClick={trashItem}>
            <img src={trashIcon} width={13} />
          </span>
          <Tooltip
            placement="top"
            target={`trash${id}`}
            arrow="true"
            isOpen={state.trashTooltipOpen}
            toggle={trashToggle}
          >
            {isProduct &&
              (isProductTrashTab ? "Delete Permanently" : "Add to Trash")}
            {!isProduct &&
              (iVideoTrashTab ? "Delete Permanently" : "Add to Trash")}
          </Tooltip>
        </div>
      {is_index ? null : (
        <div className="note-container">
          <span role="button" id={`edit${id}`} onClick={toggleOpen}>
            <Edit size={17} color={text ? "#6428e5" : "#989898"} />{" "}
          </span>
          <Tooltip
            placement="top"
            target={`edit${id}`}
            arrow="true"
            isOpen={state.editTooltipOpen}
            toggle={editToggle}
          >
            Edit Note
          </Tooltip>
          {open ? (
            <NoteText
              text={text}
              update={updateText}
              submit={submitText}
              isCreator={isCreatorNote}
            />
          ) : null}
        </div>
      )}
      {product_edit ? (
        <div>
          <span role="button" id={`editPro${id}`} onClick={showProductEdit}>
            <Edit2 size={15} color="#989898" />
          </span>
          <Tooltip
            placement="top"
            target={`editPro${id}`}
            arrow="true"
            isOpen={state.editProductTooltipOpen}
            toggle={editProToggle}
          >
            Edit
          </Tooltip>
          {openEditProduct && (
            <EditProduct
              product_id={id}
              open={openEditProduct}
              showProductEdit={showProductEdit}
              tab={tab}
            />
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default NoteSection;
